import {
  getConfig,
  getLayout,
  getPaint,
  getStyleType,
  getTextField,
} from './layerStyler'

export default function martinVectorTileLayers(map, localAuth) {
  var layerList = []
  var configList = []

  var tile_URL = 'http://20.64.148.171:3040'
  if (process.env.NODE_ENV === 'production')
    tile_URL = 'https://tiles.hydrascore.com'

  var layerJson = {
    rated_wd_mat_vw: [
      'Rated Regions - Water Districts',
      'MULTIPOLYGON',
      '',
      'Default Layers',
    ],
    rated_gsa_mat_vw: [
      'Rated Regions - GSAs',
      'MULTIPOLYGON',
      '',
      'Default Layers',
    ],
    hydra_wd_vw: ['Water Districts', 'MULTIPOLYGON', '', 'Default Layers'],
    hydra_gsa: ['GSA', 'MULTIPOLYGON', '', 'Default Layers'],
    sgma_county: ['County', 'MULTIPOLYGON', '', 'Default Layers'],
    sgma_sagbi: ['SAGBI', 'MULTIPOLYGON', '', 'Default Layers'],
    state_wide_parcels_2024: [
      'Statewide Parcels',
      'MULTIPOLYGON',
      '',
      'Default Layers',
    ],
    sgma_sagbi_unmod: [
      'Unmodified SAGBI',
      'MULTIPOLYGON',
      '',
      'Default Layers',
    ],
    sgma_ewrims: [
      'Water Rights (eWRIMS)',
      'POINT',
      '#4287f5',
      'Default Layers',
    ],
    provisional_crops_2023: [
      'Statewide Crops',
      'MULTIPOLYGON',
      '',
      'Default Layers',
    ],
    aac_ca_region: ['AAC CA Territory', 'MULTIPOLYGON', '', 'Default Layers'],
    fca_territories_2024: [
      'Farm Credit System Institution Territories (2024)',
      'MULTIPOLYGON',
      '',
      'Default Layers',
    ],
    ca_grape_pricing_districts: [
      'Grape Pricing Districts',
      'MULTIPOLYGON',
      '',
      'Default Layers',
    ],
    yfc_territory : [
      'YFC Territory',
      'MULTIPOLYGON',
      '',
      'Default Layers',
    ],
    // "function_user_ranch_parcels":["All Ranches", "MULTIPOLYGON", "", "Default Layers"],
  }
  for (const [key, value] of Object.entries(layerJson)) {
    if (key === ' function_user_ranch_parcels') {
      if (value[1] !== 'POINT') {
        layerList.push([
          {
            key: key,
            id: key,
            type: 'vector',
            url: tile_URL + '/' + key + '?session_key=' + localAuth.sessionKey,
          },
          {
            key: value[0],
            id: value[0],
            type: getStyleType(value[1]),
            'source-layer': key,
            layout: getLayout(value[1], 'visible'),
            paint: getPaint(value[1], value[2], key),
          },
          {
            key: value[0] + '_outline',
            id: value[0] + '_outline',
            type: getStyleType('OUTLINE'),
            'source-layer': key,
            layout: getLayout('OUTLINE', 'visible'),
            paint: getPaint('OUTLINE', value[2], key),
          },
        ])
        configList.push(
          getConfig(
            value[0] + '_outline',
            value[3],
            'OUTLINE',
            tile_URL +
              '/' +
              key +
              '/{z}/{x}/{y}?session_key=' +
              localAuth.sessionKey
          )
        )
      } else {
        layerList.push([
          {
            key: key,
            id: key,
            type: 'vector',
            url: tile_URL + '/' + key + '?session_key=' + localAuth.sessionKey,
          },
          {
            key: value[0],
            id: value[0],
            type: getStyleType(value[1]),
            'source-layer': key,
            layout: getLayout(value[1], 'visible'),
            paint: getPaint(value[1], value[2], key),
          },
        ])
        configList.push(
          getConfig(
            value[0] + '_outline',
            value[3],
            'OUTLINE',
            tile_URL +
              '/' +
              key +
              '/{z}/{x}/{y}?session_key=' +
              localAuth.sessionKey
          )
        )
      }
      configList.push(
        getConfig(
          value[0],
          value[3],
          value[1],
          tile_URL +
            '/' +
            key +
            '/{z}/{x}/{y}?session_key=' +
            localAuth.sessionKey
        )
      )
    } else if (
      key === 'state_wide_parcels_2024' ||
      key === 'hydra_wd_vw' ||
      key === 'hydra_gsa' ||
      key === 'sgma_county' ||
      key === 'provisional_crops_2023' ||
      key === 'aac_ca_region' ||
      key === 'fca_territories_2024' ||
      key === 'ca_grape_pricing_districts' ||
      key === 'yfc_territory'
    ) {
      const labelText =
        key === 'state_wide_parcels_2024'
          ? getTextField(['parcel_id', 'owner'])
          : key === 'hydra_wd_vw'
            ? getTextField(['agencyname'])
            : key === 'hydra_gsa'
              ? getTextField(['gsa_name'])
              : key === 'sgma_county'
                ? getTextField(['namelsad'])
                : key === 'provisional_crops_2023'
                  ? getTextField(['main_crop'])
                  : key === 'aac_ca_region'
                    ? getTextField(['name'])
                    : key === 'fca_territories_2024'
                      ? getTextField(['district', 'name'])
                      : key === 'ca_grape_pricing_districts'
                        ? getTextField(['district'], {'district': 'District No : '})
                        : key === 'yfc_territory'
                          ? getTextField(['name'])
                          : ''
      layerList.push([
        {
          key: key,
          id: key,
          type: 'vector',
          url: tile_URL + '/' + key,
        },
        {
          key: value[0],
          id: value[0],
          type: getStyleType(value[1]),
          'source-layer': key,
          layout: getLayout(value[1], 'visible'),
          paint: getPaint(value[1], value[2], key),
        },
        {
          key: value[0] + '_outline',
          id: value[0] + '_outline',
          type: getStyleType('OUTLINE'),
          'source-layer': key,
          layout: getLayout('OUTLINE', 'visible'),
          paint: getPaint('OUTLINE', value[2], key),
        },
        {
          key: value[0] + '_label',
          id: value[0] + '_label',
          type: 'symbol',
          'source-layer': key,
          layout: {
            visibility: 'visible',
            'icon-image': '',
            'text-field': labelText,
            'text-font': ['Roboto Condensed Bold'],
            'text-offset': [0, 0],
            'text-letter-spacing': 0,
            'text-anchor': 'top',
            'text-size': 14,
          },
          paint: {
            'text-color': '#2c2c2c',
            'text-halo-color': '#ffffff',
            'text-halo-width': 2,
          },
        },
      ])
    } else {
      if (value[1] !== 'POINT') {
        layerList.push([
          {
            key: key,
            id: key,
            type: 'vector',
            url: tile_URL + '/' + key,
          },
          {
            key: value[0],
            id: value[0],
            type: getStyleType(value[1]),
            'source-layer': key,
            layout: getLayout(value[1], 'visible'),
            paint: getPaint(value[1], value[2], key),
          },
          {
            key: value[0] + '_outline',
            id: value[0] + '_outline',
            type: getStyleType('OUTLINE'),
            'source-layer': key,
            layout: getLayout('OUTLINE', 'visible'),
            paint: getPaint('OUTLINE', value[2], key),
          },
        ])
        configList.push(
          getConfig(
            value[0] + '_outline',
            value[3],
            'OUTLINE',
            tile_URL + '/' + key + '/{z}/{x}/{y}'
          )
        )
      } else {
        layerList.push([
          {
            key: key,
            id: key,
            type: 'vector',
            url: tile_URL + '/' + key,
          },
          {
            key: value[0],
            id: value[0],
            type: getStyleType(value[1]),
            'source-layer': key,
            layout: getLayout(value[1], 'visible'),
            paint: getPaint(value[1], value[2], key),
          },
        ])
        configList.push(
          getConfig(
            value[0],
            value[3],
            value[1],
            tile_URL + '/' + key + '/{z}/{x}/{y}'
          )
        )
      }
    }
  }
  return { layerList, configList }
}
